import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { navy, glass, transition } from './colorUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Table', 'blueTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}-wrapper ${componentCls}${DOT_PREFIX}`]: {
      transition,
      background: 'transparent',

      // 表头 —— 半透明深蓝 + 白色文字
      [`${componentCls}-thead > tr > th, ${componentCls}-thead > tr > td`]: {
        background: `${glass.header} !important`,
        borderBottom: `1px solid ${navy[700]} !important`,
        color: `#fff !important`,
        fontWeight: 600,
        fontSize: '13px',
        letterSpacing: '0.3px',
      },

      // 表体行
      [`${componentCls}-tbody > tr > td`]: {
        borderBottom: `1px solid ${navy[700]}60 !important`,
        color: '#e2e8f0',
        transition,
      },

      // 行 hover —— 荧光蓝微光
      [`${componentCls}-tbody > tr:hover > td`]: {
        background: `${glass.hover} !important`,
      },

      // 选中行
      [`${componentCls}-tbody > tr${componentCls}-row-selected > td`]: {
        background: `${glass.selected} !important`,
      },

      // 固定列
      [`${componentCls}-cell-fix-left, ${componentCls}-cell-fix-right`]: {
        background: `${navy[900]} !important`,
      },
    },
  }
})
